<template>
  <div class="sf-pageheader sf-border-box sf-layer-border-bottom">
    <div class="sf-grid sf-grid-wide">
      <div class="sf-row">
        <div class="sf-col sf-xs-12">
          <div class="sf-level sf-level-between">
            <div class="sf-level-item">
              <div class="sf-pageheader-title sf-below-1">
                <span>{{ pageTitle }}</span>
              </div>
              <div class="sf-level">
                <a :href="reportTemplate.editUrl" class="sf-level sf-font-m">{{
                  reportTemplate.name
                }}</a
                ><span
                  v-if="reportTemplate.graphsUrl"
                  class="sf-font-s sf-c-text-light fa fa-chevron-right"
                ></span
                ><a
                  v-if="reportTemplate.graphsUrl"
                  :href="reportTemplate.graphsUrl"
                  class="sf-level sf-font-m"
                  data-walkthrough-id="chart-editor-breadcrumbs-charts"
                  >{{ I18n.t('report/template.sidebar.graphs') }}</a
                ><span
                  class="sf-font-s sf-c-text-light fa fa-chevron-right"
                ></span
                ><span class="sf-font-m sf-fwdb sf-c-text-darker">{{
                  graphCurrentTitle
                }}</span>
              </div>
            </div>
            <div class="sf-level-item sf-level">
              <div class="sf-level">
                <div class="sf-form-select-wrapper">
                  <select
                    v-model="locale"
                    class="sf-form-select"
                    name="language"
                  >
                    <option
                      v-for="lang in graphAvailableLanguages"
                      :key="lang.locale"
                      :value="lang.locale"
                    >
                      {{ lang.language }}
                    </option>
                  </select>
                </div>
              </div>
              <button
                v-if="isPersisted && !readOnly"
                class="sf-btn sf-c-danger"
                @click="destroyWithConfirm()"
              >
                {{ I18n.t('js.report_graph.edit.destroy') }}</button
              ><button
                v-if="!readOnly && !saving"
                class="sf-btn sf-btn-success"
                data-walkthrough-id="chart-editor-save"
                @click="submit()"
              >
                {{ I18n.t('js.report_graph.edit.save') }}
              </button>
              <div v-if="!readOnly && saving">
                <div class="sf-spinner sf-spinner-s"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

const ENTER = 'Enter'
const TEXTAREA = 'TEXTAREA'

export default {
  computed: {
    ...mapState(['reportTemplate', 'currentLocale', 'readOnly', 'saving']),
    ...mapGetters([
      'graphCurrentTitle',
      'graphAvailableLanguages',
      'isPersisted',
    ]),
    pageTitle() {
      if (this.isPersisted) {
        return I18n.t('js.report_graph.edit.title.edit')
      } else {
        return I18n.t('js.report_graph.edit.title.new')
      }
    },
    locale: {
      get() {
        return this.currentLocale
      },
      set(newLocale) {
        this.setCurrentLocale({ locale: newLocale })
      },
    },
  },
  mounted() {
    if (!this.readOnly) {
      document.body.addEventListener('keyup', (event) => {
        if (event.key === ENTER && event.target.tagName !== TEXTAREA) {
          this.submit()
        }
      })
    }
  },
  methods: {
    ...mapActions(['setCurrentLocale', 'deleteGraph', 'saveGraph']),
    destroyWithConfirm() {
      window.sfRemoveConfirm({
        name: this.graphCurrentTitle,
        onConfirm: this.deleteGraph,
      })
    },
    submit() {
      this.saveGraph()
    },
  },
}
</script>
